import React from 'react';
import DashboardContent from './components/DashboardContent';

const Dashboard: React.FC = () => {
  return (
    <div className="min-h-screen">
      <DashboardContent />
    </div>
  );
};

export default Dashboard;
